import { Box, PaperProps } from '@mui/material'
import { CloseModalIcon, DefaultIconBlue } from 'images'
import React, { FC, memo, useCallback } from 'react'
import Draggable from 'react-draggable'
import { Comment } from 'search/context/types'
import { Date, Author, CommentInfo, SContent, SHeader, SPaper, SDialog } from './styled'
import { LazyImage } from 'components/LazyImage'

interface GetCommentModalProps {
    comment: Comment[]
    onClose: () => void
    isOpen: boolean
}

const GetCommentModal: FC<GetCommentModalProps> = memo(({ comment, onClose, isOpen }) => {
    const nodeRef = React.useRef(null)

    const PaperComponent = useCallback(
        (props: PaperProps) => {
            return (
                <Draggable
                    handle="#draggable-dialog-title"
                    cancel={'[class*="MuiDialogContent-root"]'}
                    nodeRef={nodeRef}
                >
                    <SPaper {...props} ref={nodeRef} />
                </Draggable>
            )
        },
        [nodeRef]
    )

    return (
        <SDialog
            ref={nodeRef}
            open={isOpen}
            onClose={onClose}
            hideBackdrop
            fullWidth={true}
            maxWidth={'xs'}
            aria-labelledby="draggable-dialog-title"
            PaperComponent={PaperComponent}
        >
            <SHeader id="draggable-dialog-title">
                Comment
                <Box component="div" sx={{ cursor: 'pointer' }}>
                    <CloseModalIcon
                        onClick={(event) => {
                            event.stopPropagation()
                            onClose()
                        }}
                    />
                </Box>
            </SHeader>
            {comment.map((item,index) => (
                <SContent key={index}>
                    {item.text}
                    <CommentInfo>
                        <Date>{item.date}</Date>
                        <Author>
                            <LazyImage
                                width="24px"
                                height="24px"
                                borderRadius="50%"
                                src={item?.staffing_pic || item?.google_pic}
                                fallbackImg={<DefaultIconBlue style={{ width: '24px', height: '24px' }} />}
                                withoutBorder
                            />
                            {item.author}
                        </Author>
                    </CommentInfo>
                </SContent>
            ))}
        </SDialog>
    )
})

export default GetCommentModal
